import React from 'react';
import withStyles from '../utils/withStyles';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';

function NineBoxCell({classes, label, employees, bg, color}) {
    return (
        <div className={classes.cell} style={{backgroundColor: bg, color}}>
            <div className={classes.header}>
                <Typography variant="body2" style={{fontWeight: 600, color: 'inherit'}}>
                    {label}
                </Typography>
                <Typography variant="body2" style={{fontWeight: 600, color: 'inherit', opacity: 0.7}}>
                    {employees.length}
                </Typography>
            </div>
            <div className={classes.chipContainer}>
                {employees.map((emp, i) => (
                    <Chip
                        key={i}
                        label={emp.name}
                        size="small"
                        className={classes.chip}
                        onClick={() => window.open(`#/label/${emp.id}`, '_blank')}
                        clickable
                    />
                ))}
            </div>
        </div>
    );
}

const styles = {
    cell: {
        minHeight: 140,
        aspectRatio: '2.6 / 1',
        padding: '20px 20px',
        margin: '6px 6px',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 12,
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 8,
    },
    chipContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 4,
        overflowY: 'auto',
        flex: 1,
    },
    chip: {
        backgroundColor: 'rgba(255,255,255,0.85)',
        color: '#333',
        fontSize: 11,
        fontWeight: 700,
    },
};

export default withStyles(styles)(NineBoxCell);
